import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Features from '../../pages/BillingPage/components/features';
import Accordion from 'shared/Accordion';
import PrimaryButton from 'shared/buttons/PrimaryButton';
import { ButtonColor, ButtonType } from 'shared/buttons/models/ButtonModels';
import PageDimmer from 'shared/wizard/components/PageDimmer';
import { AccordionType } from 'shared/utils/accordionHelper';

export default () => {
  const [open, setOpen] = useState(false);
  const history = useHistory();
  const subscription = useSelector((state) => state.profile.subscription);
  const { chartsCreated, team } = useSelector((state) => state.profile);
  const paths = useSelector((state) => state.app.paths);

  const featureMap = {
    1: 0,
    9: 1,
    10: 2,
    11: 3,
    12: 1,
    13: 2,
    14: 3,
    15: 3,
    16: 2,
    17: 0,
    18: 2
  };
  const mappedFeatureIndex = featureMap[subscription ? subscription.id : 1];
  const onStoragePlan = subscription && subscription.id === 17;
  const currentLevel = Features[mappedFeatureIndex];
  const nextLevel = Features[mappedFeatureIndex + 1];

  const readPercentOverfilled = () => {
    const min = chartsCreated || 0;
    const max = team ? team.charts_max : 10;

    return Math.min((min / max) * 100, 100);
  };

  const readProgressTemperature = () => {
    if (chartsCreated >= team?.charts_max) {
      return ' danger max';
    }
    return ' danger';
  };

  const toggle = () => {
    setOpen(!open);
  };
  const goToSubscriptionPage = () => {
    setOpen(false);
    history.push(paths.profileSubscription);
  };

  const close = () => setOpen(false);

  return (
    <div className="content-center min-w-[200px]">
      {open && <PageDimmer onClick={close} className="opacity-0" />}
      <Accordion
        accordionClasses={
          'bg-ev-light-orange relative w-full group hover:bg-ev-baby-blue-2 hover:text-ev-navy-blue-2 active:bg-ev-navy-blue-2 active:text-white active:border-ev-navy-blue-2'
        }
        accordionType={AccordionType.Compact}
        childrenClasses="absolute z-[10000000] w-full p-0 m-0 mt-[45px] top-[-5px] flex-col"
        headerText={
          <div className="flex-col w-full px-3 py-1 text-ev-navy-blue bg-ev-light-orange rounded group-hover:bg-ev-baby-blue-2 group-hover:text-ev-navy-blue-2  group-active:bg-ev-navy-blue-2 group-active:text-white">
            {!onStoragePlan && (
              <div className="flex justify-between w-full space-x-2 transition">
                <p className="text-xs mb-2">
                  <span className="text-xs font-bold">
                    {chartsCreated ?? 0} of {team?.charts_max}{' '}
                  </span>{' '}
                  <span className="font-normal">projects used</span>
                </p>
              </div>
            )}

            {onStoragePlan && <p className="hidden mb-0 py-2 text-xs font-bold md:block">Storage Plan</p>}

            {!onStoragePlan && (
              <div className="w-full h-1 mb-1 bg-white rounded-full transition">
                <div
                  className={`progress-charts-bar rounded-full ${readProgressTemperature()} h-1`}
                  style={{ width: `${readPercentOverfilled()}%` }}
                />
              </div>
            )}
          </div>
        }
        selected={open}
        onClick={toggle}
      >
        <div className="p-4 pt-2 m-0 text-ev-navy-blue bg-ev-light-orange rounded">
          <p className="text-xs font-medium text-ev-navy-blue">
            Your subscription:{' '}
            <span className="text-xs font-bold">{onStoragePlan ? 'Storage' : currentLevel.name}</span>
          </p>
          <hr className="my-2 border-t-ev-red-2" />
          <p className="text-xs mb-2 font-bold">Upgrade to {nextLevel.name}:</p>
          <ul className="pl-0 space-y-2 list-none">
            {nextLevel.features.map((feat, i) => (
              <li className="text-xs flex items-center" key={`upsell_${i}`}>
                <span className="text-xs font-bold pr-1">+ </span> {feat}
              </li>
            ))}
          </ul>
          <PrimaryButton
            text="Go to subscriptions"
            onClick={goToSubscriptionPage}
            buttonType={ButtonType.Info}
            buttonColor={ButtonColor.White}
            className="text-xs w-full"
          />
        </div>
      </Accordion>
    </div>
  );
};
